import BankAccountCard from './BankAccountCard';

export default BankAccountCard;
